import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import BoardsAPI from '../../api/boards';

export const state = {
  records: [],
  board: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isUpdatingIMAP: false,
    isUpdatingSMTP: false,
  },
};

export const getters = {
  getBoards($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};


export const actions = {
  revalidate: async ({ commit }, { newKey }) => {
    try {
      const isExistingKeyValid = await BoardsAPI.validateCacheKey(newKey);
      if (!isExistingKeyValid) {
        const response = await BoardsAPI.refetchAndCommit(newKey);
        commit(types.default.SET_BOARDS, response.data.payload);
      }
    } catch (error) {
      // Ignore error
    }
  },
  get: async ({ commit }) => {
    commit(types.default.SET_BOARDS_UI_FLAG, { isFetching: true });
    try {
      const response = await BoardsAPI.get(true);
      commit(types.default.SET_BOARDS_UI_FLAG, { isFetching: false });
      commit(types.default.SET_BOARDS, response.data?.payload);
    } catch (error) {
      commit(types.default.SET_BOARDS_UI_FLAG, { isFetching: false });
    }
  },
  delete: async ({ commit }, inboxId) => {
    commit(types.default.SET_BOARDS_UI_FLAG, { isDeleting: true });
    try {
      await BoardsAPI.delete(inboxId);
      commit(types.default.DELETE_INBOXES, inboxId);
      commit(types.default.SET_BOARDS_UI_FLAG, { isDeleting: false });
    } catch (error) {
      commit(types.default.SET_BOARDS_UI_FLAG, { isDeleting: false });
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.default.SET_BOARDS_UI_FLAG]($state, uiFlag) {
    $state.uiFlags = { ...$state.uiFlags, ...uiFlag };
  },
  [types.default.SET_BOARDS]: MutationHelpers.set,
  [types.default.ADD_BOARDS]: MutationHelpers.create,
  [types.default.EDIT_BOARDS]: MutationHelpers.update,
  [types.default.DELETE_BOARDS]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
